import React, { useState } from 'react'
import { CustomDialog } from '@/components/dialogs/custom-dialog'
import { User, UserProps } from '@/entities/user'
import { formatNumberWithCurrency } from '@/utils/dashboard-dates-util'
import MetricCard from '../dashboard/metric-card'
import { DollarSign, MessageCircle, BookOpen } from 'lucide-react'
import { HotmartData } from '@/components/common/hotmart-data'

// types
type UserDetailsDialogProps = {
  user: UserProps | User
  open: boolean
  isLoading: boolean
  hotmartData: unknown
  cb: () => void
}

// variables
const loc = 'components/dialogs/user-details-dialog'

export function UserDetailsDialog({ user, open, hotmartData, isLoading, cb }: UserDetailsDialogProps) {
  const [isOpen, setIsOpen] = useState<boolean>(open)

  const [userData] = useState<User>(new User(user))

  const _handleCancel = async () => {
    setIsOpen(false)
    cb()
  }

  return (
    <CustomDialog open={isOpen} persistent={true} title="Detalhes do usuário" confirmationBeforeClose={false} onClose={_handleCancel} className="min-w-screen">
      <div className="grid grid-cols-1 xs:grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 3xl:grid-cols-2 4xl:grid-cols-2 gap-2 min-w-full">
        <MetricCard title="Valor Em Compras" value={formatNumberWithCurrency(userData.totalSpentInPurchases)} icon={<DollarSign className="h-6 w-6" />} color="indigo" isLoading={isLoading} />
        <MetricCard title="Saldo Atual" value={formatNumberWithCurrency(userData.currentBalance)} icon={<DollarSign className="h-6 w-6" />} color="indigo" isLoading={isLoading} />
        <MetricCard title="Valor Gasto Em Conversas" value={formatNumberWithCurrency(userData.totalSpentInChat)} icon={<DollarSign className="h-6 w-6" />} color="indigo" isLoading={isLoading} />
        <MetricCard title="Valor Gasto Em Exames" value={formatNumberWithCurrency(userData.totalSpentInExams)} icon={<DollarSign className="h-6 w-6" />} color="indigo" isLoading={isLoading} />
        <MetricCard title="Quantidade de mensagens enviadas" value={`${userData.messages?.length} mensagens`} icon={<MessageCircle className="h-6 w-6" />} color="indigo" isLoading={isLoading} />
        <MetricCard title="Quantidade de exames consultados" value={`${userData.examConsultants?.length} exames`} icon={<BookOpen className="h-6 w-6" />} color="indigo" isLoading={isLoading} />
      </div>
      
      <HotmartData hotmartData={hotmartData} isLoading={isLoading} />
    </CustomDialog>
  )
}
